import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { MButtonIconProps } from '../MButtonIcon/MButtonIcon.types';

export enum MModalHeaderDEFAULT_I18N {
  closeDialog = 'Close dialog',
}

export interface MModalHeaderI18nProviderProps {
  closeDialog?: string;
}

type MModalHeaderButtonIconProps = Omit<MButtonIconProps, 'aria-label' | 'aIcon'> & {
  'aria-label'?: string;
};

export interface MModalHeaderProps {
  aSubheader: ASubheaderProps;
  mButtonIcon: MModalHeaderButtonIconProps;
  i18nProperties?: MModalHeaderI18nProviderProps;
  className?: string;
}
